import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IonPopover, ModalController } from '@ionic/angular';
import { Category } from '../../../domains/training/category/category.model';
import { ProductInstallationTypeClaimed } from '../../../domains/training/product-installation-types-claimed/product-installation-types-claimed.model';
import { SkillsAndExperienceFacade } from '../../../domains/training/skills-and-experience.facade';
import { TrainingFacade } from '../../../domains/training/training/training.facade';
import { Training } from '../../../domains/training/training/training.model';
import { TrainingClaimed } from '../../../domains/training/trainings-claimed/trainings-claimed.model';
import { ItemChooserOption } from '../../../shared/components/item-chooser-list/item-chooser-option.model';
import { handleDatePickerDismiss } from '../../../shared/utils/date-picker-popover';

@Component({
  selector: 'gc-claim-categorized-training-modal',
  templateUrl: './claim-categorized-training-modal.component.html',
  styleUrls: ['./claim-categorized-training-modal.component.scss'],
})
export class ClaimCategorizedTrainingModalComponent {
  @Input() claimedInstallType!: ProductInstallationTypeClaimed;
  @Input() category!: Category;

  training: Training = undefined as any;
  pendingClaims: TrainingClaimed[] = [];
  claimDateControl = new FormControl<Date | null>(null);

  constructor(
    public readonly modalGC: ModalController,
    public skillsAndExperience: SkillsAndExperienceFacade,
    public trainingsFacade: TrainingFacade,
  ) {}

  async chooseTraining(training: Training): Promise<void> {
    this.training = training;
  }

  openDatePicker(
    popoverGC: IonPopover,
    event: MouseEvent | TouchEvent | PointerEvent | CustomEvent,
    training: Training,
  ): void {
    this.chooseTraining(training);
    this.claimDateControl.setValue(null);
    popoverGC.present(event);
  }

  async finalizeChoice(popoverGC: IonPopover): Promise<boolean> {
    const date = this.claimDateControl.value;
    if (!date) {
      return false;
    }

    await popoverGC.dismiss();
    const nextClaim = {
      trainingId: this.training.id,
      categoryId: this.category.id,
      productInstallationTypeId: this.claimedInstallType.productInstallationTypeId,
      productInstallationTypeClaimedId: this.claimedInstallType.id,
      dateClaimed: new Date(date),
      completedOn: new Date(date),
      isVerified: false,
    } as TrainingClaimed;
    this.pendingClaims = [
      ...this.pendingClaims.filter(claim => claim.trainingId !== nextClaim.trainingId),
      nextClaim,
    ];
    return true;
  }

  onDatePickerDismiss(popoverGC: IonPopover, status: 'cancel' | 'confirm'): void {
    handleDatePickerDismiss(popoverGC, status, () => this.finalizeChoice(popoverGC));
  }

  isAdded(item: ItemChooserOption<Training>): boolean {
    return item.added || this.pendingClaims.some(claim => claim.trainingId === item.value.id);
  }

  submit(): Promise<TrainingClaimed[] | boolean> {
    if (!this.pendingClaims.length) {
      return Promise.resolve(false);
    }

    return this.modalGC.dismiss(this.pendingClaims, 'ok');
  }
}
